import API from './api';

export class FormServices extends API {
  static baseURL = API.env.REACT_APP_BASE_API_LOCAL || '';
  constructor() {
    super(FormServices.baseURL);
  }
 
  fetchFormConfig = async (moduleName) => (
    this.responsify(await this.instance.get('form-configurations/list', { params: { moduleName } }))
  );

  getListAllOrgConfig = async (roleId, moduleId, name) => (
    this.responsify(await this.instance.get('form-configurations/list-org-config',{params:{roleId, moduleId, name}}))
  );

  postOrgConfig = async (formData) => (
    this.responsify(await this.instance.post('form-configurations/create-update', formData))
  );

  getOrgConfigDetail = async (id) => (
    this.responsify(await this.instance.get('form-configurations/details', {params: {id}}))
  );

  deleteOrgConfigDetail = async (id) => (
    this.responsify(await this.instance.delete('form-configurations/delete-details', {params: {id}}))
  );
}